import React, { createContext, useContext, useState, useCallback } from "react";
import { extraStrings } from "@/locales";

const dict = {
  es: {
    app_name: "ClinicOS",
    tagline: "Expediente clínico digital conforme a la NOM-004-SSA3-2012",
    hero_title: "Gestión clínica para México, hecha simple",
    hero_sub: "Clínicas, médicos, pacientes, citas, recetas y expedientes — todo en un solo lugar, con cumplimiento NOM-004 e inteligencia artificial.",
    get_started: "Comenzar",
    login: "Iniciar sesión",
    register: "Crear cuenta",
    logout: "Cerrar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    role: "Tipo de cuenta",
    clinic: "Clínica",
    doctor: "Médico",
    sign_in: "Entrar",
    sign_up: "Registrarme",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    or: "o",
    dashboard: "Tablero",
    profile: "Perfil",
    doctors: "Médicos",
    clinics: "Clínicas",
    catalogs: "Catálogos",
    catalog_specialties: "Especialidades médicas",
    catalog_blood_types: "Grupos sanguíneos",
    catalog_administration_routes: "Vías de administración",
    catalog_note_types: "Tipos de nota médica",
    catalog_sexes: "Sexo",
    catalog_establishment_types: "Tipos de establecimiento",
    catalog_cie10: "Diagnósticos CIE-10",
    add_item: "Agregar elemento",
    code: "Código",
    active: "Activo",
    inactive: "Inactivo",
    catalogs_intro: "Catálogos de referencia conforme a la NOM-004-SSA3-2012. Administra los valores usados en toda la plataforma.",
    patients: "Pacientes",
    appointments: "Citas",
    prescriptions: "Recetas",
    medical_records: "Notas médicas",
    welcome: "Bienvenido",
    total_clinics: "Clínicas",
    total_doctors: "Médicos",
    total_patients: "Pacientes",
    total_appointments: "Citas",
    today_appointments: "Citas de hoy",
    new: "Nuevo",
    add: "Agregar",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    actions: "Acciones",
    search: "Buscar...",
    logo: "Logotipo",
    address: "Dirección",
    phone: "Teléfono",
    specialty: "Especialidad",
    cedula: "Cédula profesional",
    university: "Universidad",
    social_networks: "Redes sociales",
    facebook: "Facebook",
    instagram: "Instagram",
    website: "Sitio web",
    profile_saved: "Perfil actualizado",
    add_doctor: "Agregar médico",
    invite_doctor: "Invitar médico",
    invitations: "Invitaciones",
    pending_invitations: "Invitaciones pendientes",
    send_invite: "Enviar invitación",
    invite_sent: "Invitación creada",
    resend_invite: "Reenviar invitación",
    previous: "Anterior",
    next: "Siguiente",
    page: "Página",
    of: "de",
    copy_link: "Copiar enlace",
    link_copied: "Enlace copiado",
    revoke: "Revocar",
    invite_email_note: "Comparte este enlace con el médico para que se una a tu clínica.",
    invite_title: "Te han invitado a unirte",
    invite_join: "Únete a {clinic} en ClinicOS",
    accept_invite: "Aceptar invitación",
    invite_create_account: "Crea tu cuenta de médico para continuar.",
    invite_existing: "Ya tienes una cuenta. Inicia sesión para unirte a la clínica.",
    invite_invalid: "Esta invitación no es válida o ha expirado.",
    invite_accepted: "¡Te uniste a la clínica!",
    status_pending: "Pendiente",
    status_accepted: "Aceptada",
    status_expired: "Expirada",
    add_clinic: "Agregar clínica",
    add_patient: "Agregar paciente",
    assign_doctor: "Asignar médico",
    assigned_doctor: "Médico asignado",
    select_specialty: "Filtrar por especialidad",
    all_specialties: "Todas las especialidades",
    select_doctor: "Seleccionar médico",
    unassigned: "Sin asignar",
    no_doctors_specialty: "No hay médicos con esa especialidad",
    new_appointment: "Nueva cita",
    list_view: "Lista",
    calendar_view: "Calendario",
    today: "Hoy",
    no_appts_day: "Sin citas este día",
    new_record: "Nueva nota médica",
    new_prescription: "Nueva receta",
    full_name: "Nombre completo",
    sex: "Sexo",
    male: "Masculino",
    female: "Femenino",
    birth_date: "Fecha de nacimiento",
    blood_type: "Grupo sanguíneo",
    emergency_contact: "Contacto de emergencia",
    allergies: "Alergias",
    ethnic_group: "Grupo étnico",
    heredo: "Antecedentes heredo-familiares",
    pathological: "Antecedentes personales patológicos",
    non_pathological: "Antecedentes personales no patológicos",
    expediente: "Expediente",
    record_type: "Tipo de nota",
    historia_clinica: "Historia clínica",
    nota_evolucion: "Nota de evolución",
    current_illness: "Padecimiento actual",
    interrogatory: "Interrogatorio por aparatos y sistemas",
    habitus: "Habitus exterior",
    temperature: "Temperatura (°C)",
    blood_pressure: "Tensión arterial",
    heart_rate: "Frecuencia cardiaca",
    resp_rate: "Frecuencia respiratoria",
    weight: "Peso (kg)",
    height: "Talla (cm)",
    physical_exam: "Exploración física",
    studies: "Resultados de estudios",
    diagnoses: "Diagnósticos / problemas clínicos",
    cie10_diagnoses: "Diagnósticos CIE-10",
    cie10_search: "Buscar código o diagnóstico CIE-10...",
    prognosis: "Pronóstico",
    therapeutic: "Indicación terapéutica",
    vital_signs: "Signos vitales",
    diagnosis: "Diagnóstico",
    medications: "Medicamentos",
    generic_name: "Nombre genérico",
    commercial_name: "Nombre comercial",
    dose: "Dosis",
    route: "Vía de administración",
    frequency: "Frecuencia",
    duration: "Duración",
    indications: "Indicaciones",
    add_medication: "Agregar medicamento",
    download_pdf: "Descargar PDF",
    date: "Fecha",
    time: "Hora",
    reason: "Motivo",
    notes: "Notas",
    status: "Estado",
    scheduled: "Agendada",
    completed: "Completada",
    cancelled: "Cancelada",
    no_show: "No asistió",
    reports: "Reportes",
    users_roles: "Usuarios y roles",
    users_sub: "Administra quién accede a ClinicOS, a qué clínica pertenece y qué puede hacer.",
    users: "Usuarios",
    roles_permissions: "Roles y permisos",
    new_user: "Nuevo usuario",
    new_user_desc: "El rol se define al crear el usuario y no se puede cambiar después.",
    all: "Todos",
    users_search: "Buscar por nombre, correo, clínica o especialidad…",
    status_active_pl: "Activos",
    status_inactive_pl: "Desactivados",
    status_active: "Activo",
    status_inactive: "Desactivado",
    users_none: "No hay usuarios con estos filtros.",
    user: "Usuario",
    last_login: "Último acceso",
    never: "Nunca",
    you: "tú",
    reset_password: "Restablecer contraseña",
    deactivate: "Desactivar",
    activate: "Activar",
    active_users: "usuarios activos",
    permission: "Permiso",
    password_hint: "Mínimo 8 caracteres. Compártela por un medio seguro.",
    doctor_clinic_hint: "Opcional: un médico puede trabajar de forma independiente.",
    doctor_move_hint: "Sus pacientes y citas existentes conservan la clínica con la que se registraron.",
    no_clinic: "Sin clínica (independiente)",
    select_clinic: "Selecciona una clínica",
    create_user: "Crear usuario",
    edit_user: "Editar usuario",
    role_fixed_hint: "El rol no se puede cambiar: está ligado a los expedientes y datos que este usuario creó.",
    new_password_is: "Nueva contraseña:",
    copy: "Copiar",
    copied: "Copiado",
    copy_failed: "No se pudo copiar; selecciona el texto y cópialo manualmente.",
    new_password_warn: "No se volverá a mostrar. Compártela por un medio seguro y pide al usuario que la cambie.",
    done: "Listo",
    reset_generate: "Generar una contraseña segura",
    reset_custom: "Escribir una contraseña",
    deactivate_q: "¿Desactivar este usuario?",
    activate_q: "¿Reactivar este usuario?",
    deactivate_desc: "No podrá iniciar sesión y su sesión actual se cerrará. Sus expedientes, recetas y citas se conservan.",
    activate_desc: "Podrá volver a iniciar sesión con su contraseña actual.",
    user_created: "Usuario creado",
    user_updated: "Usuario actualizado",
    user_activated: "Usuario reactivado",
    user_deactivated: "Usuario desactivado",
    role_super_admin: "Super admin",
    role_clinic: "Clínica",
    role_doctor: "Médico",
    role_super_admin_desc: "Administra toda la plataforma: clínicas, usuarios, catálogos NOM-004 y reportes globales.",
    role_clinic_desc: "Administra una clínica: sus médicos, pacientes, citas y reportes.",
    role_doctor_desc: "Atiende a sus pacientes: expediente clínico, notas, recetas y citas.",
    perm_full: "Completo",
    perm_scoped_clinic: "Su clínica",
    perm_scoped_own: "Sus pacientes",
    perm_read: "Solo lectura",
    perm_read_clinic: "Lectura (su clínica)",
    perm_none: "Sin acceso",
    perm_users: "Usuarios y roles",
    perm_clinics: "Alta y baja de clínicas",
    perm_catalogs: "Catálogos NOM-004 (CIE-10, especialidades…)",
    perm_doctors: "Médicos e invitaciones",
    perm_patients: "Pacientes",
    perm_appointments: "Citas",
    perm_records: "Notas médicas y recetas",
    perm_reports: "Reportes",
    perm_ai: "Asistente de IA",
    perm_profile: "Perfil y logotipo",
    roles_fixed_note: "Los permisos están definidos por el sistema. Para dar acceso distinto a una persona, crea un usuario con el rol adecuado; para quitar el acceso, desactívalo. Los usuarios no se eliminan para conservar la autoría de los expedientes (NOM-004).",
    reports_sub: "Citas, actividad de médicos, comparativo de clínicas y documentación clínica.",
    rpt_this_month: "Este mes",
    rpt_last_month: "Mes anterior",
    rpt_last_30: "Últimos 30 días",
    rpt_last_90: "Últimos 90 días",
    rpt_this_year: "Este año",
    rpt_from: "Desde",
    rpt_to: "Hasta",
    rpt_all_clinics: "Todas las clínicas",
    rpt_all_doctors: "Todos los médicos",
    rpt_no_doctor: "Sin médico asignado",
    rpt_group_by: "Agrupar por",
    rpt_auto: "Automático",
    rpt_day: "Día",
    rpt_week: "Semana",
    rpt_month: "Mes",
    rpt_total_appts: "Citas en el periodo",
    rpt_active_doctors: "Médicos con consultas",
    rpt_active_doctors_hint: "con al menos una cita completada",
    rpt_of: "de",
    rpt_patients_seen: "pacientes atendidos",
    rpt_overdue: "citas pasadas siguen como «Agendada». Márcalas como Completada, No asistió o Cancelada para que los reportes sean exactos.",
    rpt_go_appointments: "Ir a citas",
    rpt_volume: "Volumen de citas",
    rpt_volume_sub: "Citas por periodo y estado",
    rpt_chart: "Gráfica",
    rpt_table: "Tabla",
    rpt_period: "Periodo",
    rpt_total: "Total",
    rpt_week_of: "Semana del",
    rpt_doctors: "Actividad por médico",
    rpt_doctors_sub: "Incluye médicos sin citas en el periodo",
    rpt_doctor: "Médico",
    rpt_clinic: "Clínica",
    rpt_patients: "Pacientes",
    rpt_last_visit: "Última consulta",
    rpt_inactive: "Sin consultas",
    rpt_no_note: "Sin nota",
    rpt_clinics: "Comparativo de clínicas",
    rpt_doctors_col: "Médicos",
    rpt_active_col: "Activos",
    rpt_new_patients: "Pacientes nuevos",
    rpt_completed_pct: "% Completadas",
    rpt_no_show_pct: "% No asistió",
    rpt_cancelled_pct: "% Canceladas",
    rpt_docs: "Documentación clínica (NOM-004)",
    rpt_docs_sub: "Citas completadas sin nota médica registrada ese día para el paciente",
    rpt_documented: "documentadas",
    rpt_undocumented: "sin nota médica",
    rpt_all_documented: "Todas las citas completadas del periodo tienen nota médica.",
    rpt_date: "Fecha",
    rpt_patient: "Paciente",
    rpt_export: "Exportar",
    rpt_export_full: "Reporte completo",
    rpt_export_xlsx: "Excel (.xlsx)",
    rpt_export_pdf: "PDF",
    rpt_export_csv: "CSV de esta pestaña",
    rpt_export_error: "No se pudo generar el archivo. Inténtalo de nuevo.",
    rpt_tab_summary: "Resumen",
    rpt_tab_clinics: "Clínicas",
    rpt_tab_doctors: "Médicos",
    rpt_tab_docs: "Documentación",
    rpt_no_data: "Sin citas en el periodo seleccionado.",
    patient: "Paciente",
    send_reminder: "Enviar recordatorio",
    reminder_sent: "Recordatorio enviado",
    ai_assistant: "Asistente IA",
    ai_help: "Asistente médico IA",
    ai_context: "Describe el caso clínico, síntomas o pregunta...",
    generate: "Generar",
    generating: "Generando...",
    insert: "Insertar resultado",
    ai_disclaimer: "Las sugerencias de IA son orientativas. El criterio del médico tratante prevalece.",
    no_data: "Sin registros",
    confirm_delete: "¿Eliminar este registro?",
    back: "Volver",
    patient_info: "Información del paciente",
    nom_note: "Conforme a NOM-004-SSA3-2012",
    age: "Edad",
    years: "años",
    saved: "Guardado correctamente",
    error: "Ocurrió un error",
    signed_by: "Atendido por",
    attachments: "Adjuntos",
    upload_file: "Subir archivo",
    uploading: "Subiendo...",
    no_attachments: "Sin archivos adjuntos",
    att_hint: "PDF, imágenes (JPG, PNG, GIF, TIFF) · máx 20 MB",
    download: "Descargar",
    delete_att: "Eliminar",
    uploaded_by: "Subido por",
    file_too_large: "El archivo supera el límite de 20 MB",
    file_type_not_allowed: "Tipo de archivo no permitido",
    preview: "Vista previa",
    print: "Imprimir",
  },
  en: {
    app_name: "ClinicOS",
    tagline: "Digital medical records compliant with NOM-004-SSA3-2012",
    hero_title: "Clinical management for Mexico, made simple",
    hero_sub: "Clinics, doctors, patients, appointments, prescriptions and records — all in one place, NOM-004 compliant with AI assistance.",
    get_started: "Get started",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Name",
    role: "Account type",
    clinic: "Clinic",
    doctor: "Doctor",
    sign_in: "Sign in",
    sign_up: "Create account",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    or: "or",
    dashboard: "Dashboard",
    profile: "Profile",
    doctors: "Doctors",
    clinics: "Clinics",
    catalogs: "Catalogs",
    catalog_specialties: "Medical specialties",
    catalog_blood_types: "Blood types",
    catalog_administration_routes: "Administration routes",
    catalog_note_types: "Medical note types",
    catalog_sexes: "Sex",
    catalog_establishment_types: "Establishment types",
    catalog_cie10: "ICD-10 diagnoses",
    add_item: "Add item",
    code: "Code",
    active: "Active",
    inactive: "Inactive",
    catalogs_intro: "Reference catalogs compliant with NOM-004-SSA3-2012. Manage the values used across the platform.",
    patients: "Patients",
    appointments: "Appointments",
    prescriptions: "Prescriptions",
    medical_records: "Medical notes",
    welcome: "Welcome",
    total_clinics: "Clinics",
    total_doctors: "Doctors",
    total_patients: "Patients",
    total_appointments: "Appointments",
    today_appointments: "Today's appointments",
    new: "New",
    add: "Add",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    actions: "Actions",
    search: "Search...",
    logo: "Logo",
    address: "Address",
    phone: "Phone",
    specialty: "Specialty",
    cedula: "Professional license",
    university: "University",
    social_networks: "Social networks",
    facebook: "Facebook",
    instagram: "Instagram",
    website: "Website",
    profile_saved: "Profile updated",
    add_doctor: "Add doctor",
    invite_doctor: "Invite doctor",
    invitations: "Invitations",
    pending_invitations: "Pending invitations",
    send_invite: "Send invitation",
    invite_sent: "Invitation created",
    resend_invite: "Resend invitation",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    copy_link: "Copy link",
    link_copied: "Link copied",
    revoke: "Revoke",
    invite_email_note: "Share this link with the doctor to join your clinic.",
    invite_title: "You've been invited to join",
    invite_join: "Join {clinic} on ClinicOS",
    accept_invite: "Accept invitation",
    invite_create_account: "Create your doctor account to continue.",
    invite_existing: "You already have an account. Sign in to join the clinic.",
    invite_invalid: "This invitation is invalid or has expired.",
    invite_accepted: "You joined the clinic!",
    status_pending: "Pending",
    status_accepted: "Accepted",
    status_expired: "Expired",
    add_clinic: "Add clinic",
    add_patient: "Add patient",
    assign_doctor: "Assign doctor",
    assigned_doctor: "Assigned doctor",
    select_specialty: "Filter by specialty",
    all_specialties: "All specialties",
    select_doctor: "Select doctor",
    unassigned: "Unassigned",
    no_doctors_specialty: "No doctors with that specialty",
    new_appointment: "New appointment",
    list_view: "List",
    calendar_view: "Calendar",
    today: "Today",
    no_appts_day: "No appointments this day",
    new_record: "New medical note",
    new_prescription: "New prescription",
    full_name: "Full name",
    sex: "Sex",
    male: "Male",
    female: "Female",
    birth_date: "Date of birth",
    blood_type: "Blood type",
    emergency_contact: "Emergency contact",
    allergies: "Allergies",
    ethnic_group: "Ethnic group",
    heredo: "Hereditary family history",
    pathological: "Personal pathological history",
    non_pathological: "Personal non-pathological history",
    expediente: "Record No.",
    record_type: "Note type",
    historia_clinica: "Clinical history",
    nota_evolucion: "Progress note",
    current_illness: "Current illness",
    interrogatory: "Review of systems",
    habitus: "External habitus",
    temperature: "Temperature (°C)",
    blood_pressure: "Blood pressure",
    heart_rate: "Heart rate",
    resp_rate: "Respiratory rate",
    weight: "Weight (kg)",
    height: "Height (cm)",
    physical_exam: "Physical examination",
    studies: "Study results",
    diagnoses: "Diagnoses / clinical problems",
    cie10_diagnoses: "ICD-10 diagnoses",
    cie10_search: "Search ICD-10 code or diagnosis...",
    prognosis: "Prognosis",
    therapeutic: "Therapeutic indication",
    vital_signs: "Vital signs",
    diagnosis: "Diagnosis",
    medications: "Medications",
    generic_name: "Generic name",
    commercial_name: "Brand name",
    dose: "Dose",
    route: "Route",
    frequency: "Frequency",
    duration: "Duration",
    indications: "Instructions",
    add_medication: "Add medication",
    download_pdf: "Download PDF",
    date: "Date",
    time: "Time",
    reason: "Reason",
    notes: "Notes",
    status: "Status",
    scheduled: "Scheduled",
    completed: "Completed",
    cancelled: "Cancelled",
    no_show: "No-show",
    reports: "Reports",
    users_roles: "Users & roles",
    users_sub: "Manage who can access ClinicOS, which clinic they belong to and what they can do.",
    users: "Users",
    roles_permissions: "Roles & permissions",
    new_user: "New user",
    new_user_desc: "The role is set when the user is created and can't be changed later.",
    all: "All",
    users_search: "Search by name, email, clinic or specialty…",
    status_active_pl: "Active",
    status_inactive_pl: "Deactivated",
    status_active: "Active",
    status_inactive: "Deactivated",
    users_none: "No users match these filters.",
    user: "User",
    last_login: "Last login",
    never: "Never",
    you: "you",
    reset_password: "Reset password",
    deactivate: "Deactivate",
    activate: "Activate",
    active_users: "active users",
    permission: "Permission",
    password_hint: "At least 8 characters. Share it through a secure channel.",
    doctor_clinic_hint: "Optional: a doctor can work independently.",
    doctor_move_hint: "Their existing patients and appointments keep the clinic they were registered under.",
    no_clinic: "No clinic (independent)",
    select_clinic: "Select a clinic",
    create_user: "Create user",
    edit_user: "Edit user",
    role_fixed_hint: "The role can't be changed: it is tied to the records and data this user created.",
    new_password_is: "New password:",
    copy: "Copy",
    copied: "Copied",
    copy_failed: "Couldn't copy; select the text and copy it manually.",
    new_password_warn: "It won't be shown again. Share it securely and ask the user to change it.",
    done: "Done",
    reset_generate: "Generate a secure password",
    reset_custom: "Type a password",
    deactivate_q: "Deactivate this user?",
    activate_q: "Reactivate this user?",
    deactivate_desc: "They won't be able to sign in and their current session will end. Their records, prescriptions and appointments are kept.",
    activate_desc: "They'll be able to sign in again with their current password.",
    user_created: "User created",
    user_updated: "User updated",
    user_activated: "User reactivated",
    user_deactivated: "User deactivated",
    role_super_admin: "Super admin",
    role_clinic: "Clinic",
    role_doctor: "Doctor",
    role_super_admin_desc: "Runs the whole platform: clinics, users, NOM-004 catalogs and global reports.",
    role_clinic_desc: "Runs one clinic: its doctors, patients, appointments and reports.",
    role_doctor_desc: "Treats their patients: clinical record, notes, prescriptions and appointments.",
    perm_full: "Full",
    perm_scoped_clinic: "Their clinic",
    perm_scoped_own: "Their patients",
    perm_read: "Read only",
    perm_read_clinic: "Read (their clinic)",
    perm_none: "No access",
    perm_users: "Users & roles",
    perm_clinics: "Create & remove clinics",
    perm_catalogs: "NOM-004 catalogs (ICD-10, specialties…)",
    perm_doctors: "Doctors & invitations",
    perm_patients: "Patients",
    perm_appointments: "Appointments",
    perm_records: "Medical notes & prescriptions",
    perm_reports: "Reports",
    perm_ai: "AI assistant",
    perm_profile: "Profile & logo",
    roles_fixed_note: "Permissions are defined by the system. To give someone different access, create a user with the right role; to remove access, deactivate them. Users aren't deleted so record authorship is preserved (NOM-004).",
    reports_sub: "Appointments, doctor activity, clinic comparison and clinical documentation.",
    rpt_this_month: "This month",
    rpt_last_month: "Last month",
    rpt_last_30: "Last 30 days",
    rpt_last_90: "Last 90 days",
    rpt_this_year: "This year",
    rpt_from: "From",
    rpt_to: "To",
    rpt_all_clinics: "All clinics",
    rpt_all_doctors: "All doctors",
    rpt_no_doctor: "No doctor assigned",
    rpt_group_by: "Group by",
    rpt_auto: "Automatic",
    rpt_day: "Day",
    rpt_week: "Week",
    rpt_month: "Month",
    rpt_total_appts: "Appointments in period",
    rpt_active_doctors: "Doctors with visits",
    rpt_active_doctors_hint: "with at least one completed appointment",
    rpt_of: "of",
    rpt_patients_seen: "patients seen",
    rpt_overdue: "past appointments are still “Scheduled”. Mark them Completed, No-show or Cancelled so reports are accurate.",
    rpt_go_appointments: "Go to appointments",
    rpt_volume: "Appointment volume",
    rpt_volume_sub: "Appointments per period and status",
    rpt_chart: "Chart",
    rpt_table: "Table",
    rpt_period: "Period",
    rpt_total: "Total",
    rpt_week_of: "Week of",
    rpt_doctors: "Doctor activity",
    rpt_doctors_sub: "Includes doctors with no appointments in the period",
    rpt_doctor: "Doctor",
    rpt_clinic: "Clinic",
    rpt_patients: "Patients",
    rpt_last_visit: "Last visit",
    rpt_inactive: "No visits",
    rpt_no_note: "No note",
    rpt_clinics: "Clinic comparison",
    rpt_doctors_col: "Doctors",
    rpt_active_col: "Active",
    rpt_new_patients: "New patients",
    rpt_completed_pct: "% Completed",
    rpt_no_show_pct: "% No-show",
    rpt_cancelled_pct: "% Cancelled",
    rpt_docs: "Clinical documentation (NOM-004)",
    rpt_docs_sub: "Completed appointments with no medical note recorded that day for the patient",
    rpt_documented: "documented",
    rpt_undocumented: "without a medical note",
    rpt_all_documented: "Every completed appointment in the period has a medical note.",
    rpt_date: "Date",
    rpt_patient: "Patient",
    rpt_export: "Export",
    rpt_export_full: "Full report",
    rpt_export_xlsx: "Excel (.xlsx)",
    rpt_export_pdf: "PDF",
    rpt_export_csv: "CSV of this tab",
    rpt_export_error: "Could not generate the file. Please try again.",
    rpt_tab_summary: "Summary",
    rpt_tab_clinics: "Clinics",
    rpt_tab_doctors: "Doctors",
    rpt_tab_docs: "Documentation",
    rpt_no_data: "No appointments in the selected period.",
    patient: "Patient",
    send_reminder: "Send reminder",
    reminder_sent: "Reminder sent",
    ai_assistant: "AI Assistant",
    ai_help: "AI medical assistant",
    ai_context: "Describe the clinical case, symptoms or question...",
    generate: "Generate",
    generating: "Generating...",
    insert: "Insert result",
    ai_disclaimer: "AI suggestions are advisory. The treating physician's judgment prevails.",
    no_data: "No records",
    confirm_delete: "Delete this record?",
    back: "Back",
    patient_info: "Patient information",
    nom_note: "Compliant with NOM-004-SSA3-2012",
    age: "Age",
    years: "years",
    saved: "Saved successfully",
    error: "An error occurred",
    signed_by: "Attended by",
    attachments: "Attachments",
    upload_file: "Upload file",
    uploading: "Uploading...",
    no_attachments: "No attachments",
    att_hint: "PDF, images (JPG, PNG, GIF, TIFF) · max 20 MB",
    download: "Download",
    delete_att: "Delete",
    uploaded_by: "Uploaded by",
    file_too_large: "File exceeds the 20 MB limit",
    file_type_not_allowed: "File type not allowed",
    preview: "Preview",
    print: "Print",
  },
};

Object.assign(dict.es, extraStrings.es);
Object.assign(dict.en, extraStrings.en);

const warned = new Set();
const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  // t("key") or t("key", { name: "Ana" }) for "{name}" placeholders.
  const t = useCallback((key, vars) => {
    let s = dict[lang][key];
    if (s == null) {
      if (process.env.NODE_ENV !== "production" && !warned.has(key)) {
        warned.add(key);
        console.warn(`[i18n] missing key "${key}" (${lang})`);
      }
      s = key;
    }
    return vars ? s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] ?? m)) : s;
  }, [lang]);
  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "es" ? "en" : "es";
      localStorage.setItem("lang", next);
      return next;
    });
  }, []);
  return <I18nContext.Provider value={{ lang, t, toggle }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
